module.exports = __webpack_public_path__ + "img/appBarMobile.9651ff9b.png";